'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExtendableError = require('./ExtendableError');

var _ExtendableError2 = _interopRequireDefault(_ExtendableError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Typed error for when a location filed failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class LocationBodyNotValidError extends _ExtendableError2.default {
  constructor(field, message) {
    super(`location: ${field} failed validation. ${message}`);

    this.field = field;
  }
}
exports.default = LocationBodyNotValidError;